// src/helper/helper.ts
var splitWords = (text) => {
  text = text.replace(/(^\s*)|(\s*$)/gi, "");
  text = text.replace(/\n/g, " ");
  text = text.replace(/[ ]{2,}/gi, " ");
  return text.split(" ").filter((s) => !!s.trim());
};
var countWords = (text) => {
  return splitWords(text).length;
};
var getDensity = (text, keyword) => {
  var _a;
  const s = splitWords(text);
  if (s.length <= 0 || !keyword)
    return [0, 0];
  const numOfKeyword = ((_a = text.match(new RegExp(keyword, "g"))) == null ? void 0 : _a.length) || 0;
  return [Math.round(numOfKeyword * 100 / s.length), numOfKeyword];
};
var countChar = (str) => {
  return str.trim().length;
};
var wordExists = (text, keyword, firstNumChar) => {
  var _a;
  text = text.toLowerCase();
  const arrKeyword = splitWords(keyword.toLowerCase());
  if (firstNumChar) {
    let i = firstNumChar - 1;
    while (text[i] && ((_a = text[i]) == null ? void 0 : _a.trim())) {
      i++;
    }
    return arrKeyword.length > 0 && arrKeyword.every((k) => splitWords(text.slice(0, i)).includes(k));
  }
  return arrKeyword.length > 0 && arrKeyword.every((k) => splitWords(text).includes(k));
};
var insertText = (text, index, addText) => {
  return text.slice(0, index) + addText + text.slice(index);
};
var removeCharOfString = (text, bottomIndex, topIndex) => {
  return text.slice(0, bottomIndex) + text.slice(topIndex + 1);
};

export {
  splitWords,
  countWords,
  getDensity,
  countChar,
  wordExists,
  insertText,
  removeCharOfString
};
